import "./settings.css";
import { useContext, useState, useEffect } from "react";
import { Context } from "../../context/Context";
import axios from "axios";
import React from "react";
import Select from "react-select";
import { decodeHtml } from "../../utils/utils";
import { toast } from "react-toastify";

export default function Settings() {
  const { user, token, dispatch } = useContext(Context);
  const [file, setFile] = useState(null);
  const [username, setUsername] = useState(user.username);
  const [email, setEmail] = useState(user.email);
  const [bio, setBio] = useState(user.bio);
  const [password, setPassword] = useState(user.password);
  const [success, setSuccess] = useState(false);

  const PF = process.env.REACT_APP_BACKEND_URL + "/api/images";

  const [cats, setCats] = useState([]);
  const [interests, setInterests] = useState(user.interests);
  useEffect(() => {
    const getCats = async () => {
      try {
        const res = await axios.get("/categories");
        if (res.status !== 200) {
          toast.info(res.data.msg);
        }
        let cat_names = res.data.map((opt) => ({
          label: decodeHtml(opt.cat_name),
          value: opt.cat_name,
        }));
        setCats(cat_names);
      } catch (err) {
        console.error("Error fetching Genres! " + err);
        toast.error("Error Fetching Genres!");
      }
    };
    getCats();
  }, []);

  // const handleInterests = async (id) =>{
  //     // interests = [...interests, id];
  //     console.log('interests', interests);
  //     let check = true;
  //     for (var idx=0;idx <interests.length; idx++){
  //       if (interests[idx] == id){
  //         check = false;
  //         break;
  //       }
  //     }
  //     if (check){
  //       interests[interests.length] = id
  //       setInterests(interests);
  //     }
  // }
  const options = user.interests.map((opt) => ({ label: opt, value: opt }));
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch({ type: "UPDATE_START" });
    if (username === "" || email === "" || password === "") {
      alert("Please fulfill the form!");
    } else {
      const updatedUser = {
        id: user._id,
        username,
        email,
        password,
        bio,
        interests,
      };
      if (file) {
        const data = new FormData();
        let filename = file.name;
        filename = "avatar/" + filename;
        data.append("name", filename);
        data.append("file", file);
        updatedUser.profilePic = filename;
        try {
          await axios.post("/upload", data);
        } catch (err) {
          console.error("Error uploading data! " + err);
          toast.error("Error Uploading Data!")
        }
      }
      try {
        const res = await axios.put("/users/" + user._id, updatedUser);
        if (res.status !== 200) {
          toast.info(res.data.msg);
        }
        setSuccess(true);
        toast.success("Updated!")
        dispatch({ type: "UPDATE_SUCCESS", payload: res.data });
      } catch (err) {
        dispatch({ type: "UPDATE_FAILURE" });
        toast.error("Something Went Wrong!")
      }
    }
  };
  const handleDelete = async (e) => {
    if (window.confirm("Are you sure?")) {
      try {
        await axios.delete(`/users/${e}`, {
          data: { userId: e },
        }, {headers: { Authorization: `Bearer ${token}` }, });
        window.location.replace("/");
        dispatch({ type: "LOGOUT" });
      } catch (err) {
        console.error("Error deleting user! " + err);
        toast.error("Error Deleting User!");
      }
    } else {
    }
  };
  return (
    <div className="settings">
      <div className="settingsWrapper">
        <div className="settingsTitle">
          <span className="settingsUpdateTitle">Update Your Account</span>
          {success && (
            <span
              style={{ color: "green", textAlign: "center", marginTop: "20px" }}
            >
              Profile has been updated...
            </span>
            // alert("Profile has been successfully updated")
          )}
          <span className="settingsDeleteTitle" onClick={handleDelete}>
            Delete Account
          </span>
        </div>
        <form className="settingsForm" onSubmit={handleSubmit}>
          <div className="update-info">
            <label>Profile Picture</label>
            <div className="settingsPP">
              <img
                src={file ? URL.createObjectURL(file) : PF + user.profilePic}
                alt=""
              />
              <label htmlFor="fileInput">
                <i className="settingsPPIcon far fa-user-circle"></i>
              </label>
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>
            <label>Username</label>
            <input
              type="text"
              defaultValue={user.username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <label>Email</label>
            <input
              type="email"
              defaultValue={user.email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label>Password</label>
            <input
              type="password"
              defaultValue={user.password}
              placeholder={"Please enter new password"}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label>Bio</label>
            <textarea
              className="bio"
              type="text"
              defaultValue={user.bio}
              onChange={(e) => setBio(e.target.value)}
            />
            <label>Interests:</label>
            <div className="select">
              <Select
                options={cats}
                isMulti
                onChange={(opts) => setInterests(opts.map((opt) => opt.value))}
                defaultValue={options}
              />
            </div>
          </div>
          <button className="settingsSubmit" type="submit">
            Update
          </button>
        </form>
      </div>
    </div>
  );
}
